import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { Stack } from '@mui/material'
import EnergyOverallTrend from './components/EnergyTrend/EnergyTrendOverAll'
import StyledSelectField from '../../components/StyledSelectField/StyledSelectField'
import { showNotification } from '../../utils/toast.utils'
import liveDataService from '../../service/liveData.service'
import { useMonthSelectorContext } from '../../context/MonthSelectorContext'
import { useDashboardGlobalStateContext } from '../../context/DashboardGlobalStateContext'

let defaultMachine = {
  value: '',
  label: ''
}

const EnergyRecordMonthly = () => {
  const { selectedDate } = useMonthSelectorContext()
  const [isLoading, setIsLoading] = useState(false)
  const [dashboardData, setDashboardData] = useState({})
  const [selectedMachine, setSelectedMachine] = useState(defaultMachine)

  const { machines: machineOptions } = useDashboardGlobalStateContext()

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)

        const response = await liveDataService.getEnergyRecordsMonthly({
          currentDate: selectedDate,
          machine: selectedMachine.value
        })

        if (response.status === 200) {
          setDashboardData({ energyTrend: response.data.data })
        } else {
          showNotification(response.data.message, 'error')
        }
      } catch (err) {
        showNotification('Failed to fetch energy records', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    if (selectedMachine.value) {
      fetchData()
    } else {
    }
  }, [selectedDate, selectedMachine])

  useEffect(() => {
    if (machineOptions.length > 0) {
      setSelectedMachine(machineOptions[0])
    }
  }, [])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '16px'
        }}
      >
        <Stack sx={{ marginLeft: 'auto', width: '200px' }}>
          <StyledSelectField
            label=""
            placeHolderText="Select machine"
            selectedValue={selectedMachine}
            selectOptions={machineOptions}
            onChangeHandler={(value) => {
              console.log('Machine Selected:', value)
              setSelectedMachine(value)
            }}
            isMulti={false}
            isSearchable={true}
            isDisabled={false}
            noOptionsMessage="No machine found"
          />
        </Stack>

        {isLoading && <>Loading...</>}
        {!isLoading && (
          <>
            {dashboardData['energyTrend'] ? (
              <EnergyOverallTrend energyTrend={dashboardData['energyTrend']} />
            ) : (
              <p>No energy trend data available.</p>
            )}
          </>
        )}
      </Box>
    </>
  )
}

export default EnergyRecordMonthly
